module.exports = __webpack_public_path__ + "img/旺旺照妖镜6.eeaaf257.gif";